import { CardBrand } from '@m/constants/PaymentEnums';

import { IdNameObject } from '@m/types/index';

export enum PaymentMethodTypeEnum {
  Card = 'Card',
  BankAccount = 'Bank Account',
  AchCreditTransfer = 'ACH Credit Transfer',
}

export type PaymentMethod = {
  achAccountNumber?: number | null;
  achRoutingNumber?: number | null;
  bankName?: string | null;
  cardBrand: CardBrand | null;
  expiryMonth: number | null;
  expiryYear: number | null;
  id: number;
  isDefaultMethod: boolean;
  isExpired: boolean;
  isInvalid: boolean;
  last4Digits: string;
  paymentMethodType?: IdNameObject<PaymentMethodTypeEnum>;
  paymentProvider: IdNameObject;
  paymentProviderMethodId: string;
  userId: number;
  wallet?: string | null;
};
